module.exports = __webpack_public_path__ + "img/playa-del-carmen.50ad789c.jpg";